import { Modal, Title, Text, Stack } from '@mantine/core';

export const TermsPopup = ({ opened, onClose }: { opened: boolean; onClose: () => void }) => {
  return (
    <Modal opened={opened} onClose={onClose} title={<Title>Terms of Service</Title>} size="lg">
      <Stack px="lg">
        <Text>Last updated: {new Date().toLocaleDateString()}</Text>

        <Title order={4}>1. Acceptance of Terms</Title>
        <Text>
          By accessing or using the our service, you agree to be bound by these Terms of Service. If you disagree with
          any part of the terms, you may not access the service.
        </Text>

        <Title order={4}>2. User Accounts</Title>
        <Text>
          When you create an account with us, you must provide us with information that is accurate, complete, and
          current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate
          termination of your account on our service.
        </Text>

        <Title order={4}>3. User Content</Title>
        <Text>
          Our service allows you to post, link, store, share, and otherwise make available certain information, text,
          graphics, videos, or other material. You are responsible for the User Content that you post on or through the
          service, including its legality, reliability, and appropriateness.
        </Text>

        <Title order={4}>4. Prohibited Uses</Title>
        <Text>
          You may use the service only for lawful purposes and in accordance with the Terms. You agree not to use the
          service in any way that violates any applicable national or international law or regulation.
        </Text>

        <Title order={4}>5. Termination</Title>
        <Text>
          We may terminate or suspend your account immediately, without prior notice or liability, for any reason
          whatsoever, including without limitation if you breach the Terms.
        </Text>

        <Title order={4}>6. Governing Law</Title>
        <Text>
          These Terms shall be governed and construed in accordance with the laws of the jurisdiction where the company
          is established, without regard to its conflict of law provisions.
        </Text>

        <Title order={4}>7. Changes to Terms</Title>
        <Text>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is
          material, we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a
          material change will be determined at our sole discretion.
        </Text>

        <Title order={4}>8. Contact Us</Title>
        <Text>If you have any questions about these Terms, please contact us.</Text>
      </Stack>
    </Modal>
  );
};
